import React from "react";

const Stat_Bar_Graphs = () => {
  return (
    <div>
      <h1>Stat Bar Graphs</h1>
    </div>
  );
};

export default Stat_Bar_Graphs;
